import { create } from "zustand";

export interface SupportTicketState {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  reset: () => void;
}

const initialState = { isOpen: false };

export const useSupportTicketStore = create<SupportTicketState>((set) => ({
  ...initialState,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
  reset: () => set(initialState)
}));
